<template>
  <el-select
    :value="value"
    :multiple="multiple"
    :clearable="clearable"
    filterable
    remote
    :loading="loading"
    :remote-method="handleSearchDebounce"
    @focus="handleFocus"
    @change="handleValueUpdate"
    @clear="handleClear"
    v-bind="$attrs"
    v-loading="initLoading"
  >
    <el-option
      v-for="item in options"
      :key="item[valueField]"
      :label="getLabel(item)"
      :value="item[valueField]"
    />
  </el-select>
</template>

<script>
import { Vue, Component, Prop, Model } from 'vue-property-decorator'
import { debounce, flatten } from 'lodash'

@Component({
  name: 'ReadOptions'
})
export default class ReadOptions extends Vue {
  @Model('change', { default: null }) value
  @Prop({ type: String, required: true }) url
  @Prop({ type: Object, default: () => ({}) }) params
  @Prop({ type: Boolean, default: false }) multiple
  @Prop({ type: String, default: 'display_name' }) labelField
  @Prop({ type: String, default: 'id' }) valueField
  @Prop({ type: Boolean, default: true }) clearable
  @Prop({ type: String, default: 'id_in' }) idInField;
  @Prop({ type: Function }) labelFormat;
  @Prop({ type: Function }) onInitOptions;

  loading = false
  // 不要改掉这个变量名，有其他地方会通过ref访问这个变量
  options = []
  defaultOptionsIsReady = false
  DEFAULT_PARAMS = {
    page: 1,
    per_page: 10
  }

  handleSearchDebounce = debounce(this.handleSearch, 800)
  request = null;
  initLoading = false;

  getLabel(item) {
    if (this.labelFormat) {
      return this.labelFormat(item)
    }
    return item[this.labelField];
  }

  async created() {
    if (this.onInitOptions) {
      this.options = (await this.onInitOptions()) || [];
      if (this.options.length > 0) {
        return;
      }
    }
    // 初始化时如果有值则加载对应选项
    const idIn = flatten([this.value]).filter(Boolean);
    if (idIn.length > 0) {
      this.initLoading = true;
      this.fetchOptions({ [this.idInField]: idIn }).finally(() => {
        this.initLoading = false;
      })
    }
  }

  beforeDestroy() {
    if (this.request && this.request.engine) {
      this.request.engine.abort();
    }
  }

  async fetchData(params) {
    if (this.request && this.request.engine) {
      this.request.engine.abort();
    }
    const requestParams = { ...this.DEFAULT_PARAMS, ...this.params, ...params }
    const idIn = flatten([requestParams[this.idInField]]).filter(Boolean)
    this.request = this.$request.get(this.url, {
      params: { ...requestParams, [this.idInField]: idIn },
      loading: false
    })
    const { data } = await this.request;
    return data;
  }

  async fetchOptions(params) {
    this.loading = true
    try {
      this.options = await this.fetchData(params)
    } finally {
      this.loading = false
    }
  }

  async handleSearch(query) {
    await this.fetchOptions({ keyword: query });
    if (this.options.length === 0) {
      // 如果没有搜索到，则下次focus时，加载初始数据（没有keyword查出来的数据）
      this.defaultOptionsIsReady = false;
    }
  }

  async handleFocus() {
    if (!this.defaultOptionsIsReady) {
      await this.fetchOptions()
      this.defaultOptionsIsReady = true
    }
  }

  handleClear() {
    this.defaultOptionsIsReady = false
  }

  handleValueUpdate(v) {
    this.$emit('change', v)
    this.$emit('select', this.options.find(item => item[this.valueField] === v))
  }
}
</script>
